import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    const portalType = process.env.REACT_APP_PORTAL_TYPE || 'admin';
    const loginPath = `/${portalType}/login`;
    return <Navigate to={loginPath} replace />;
  }

  // Check role-based access
  if (requiredRole && user.userType !== requiredRole) {
    // Redirect to appropriate login based on user type mismatch
    if (requiredRole === 'admin' && user.userType !== 'admin') {
      return <Navigate to="/admin/login" replace />;
    }
    if (requiredRole === 'teacher' && user.userType !== 'teacher') {
      return <Navigate to="/teacher/login" replace />;
    }
    if (requiredRole === 'student' && user.userType !== 'student') {
      return <Navigate to="/student/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;